var CsAgGridCustomUserRendererComponent = /** @class */ (function () {
    function CsAgGridCustomUserRendererComponent() {
        this.assignees = [];
        this.fallbackImage = 'images/profile_avatar_small.jpg';
    }
    CsAgGridCustomUserRendererComponent.prototype.agInit = function (params) {
        this.params = params;
    };
    CsAgGridCustomUserRendererComponent.prototype.refresh = function (params) {
        this.params = params;
        return true;
    };
    return CsAgGridCustomUserRendererComponent;
}());
export { CsAgGridCustomUserRendererComponent };
